import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'subscriptionServiceState',
    standalone: false
})
export class SubscriptionServiceStatePipe implements PipeTransform {

  transform(value: any, arg: string): string {
    let transformedValue = 'INACTIVE';
    if (value && value.subscribedServices) {
      const service = value.subscribedServices.find(element => element.serviceReference === arg);
      if (service) {
        transformedValue = service.status;
      }
    }
    return transformedValue;
  }

}
